<template>
    <div class="card shadow">
        <div class="card-header bg-transparent">
            <div>
                <h3 class="mb-0">
                    {{ $t('message.edit') }} {{ $tc('message.assistante', 1) }}
                </h3>
            </div>
        </div>

        <div class="card-body">
            <b-form >
                <b-container>


                    <b-row>
                        <b-col sm="12">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="institution-group"
                                    :label="$tc('message.institutions',1)"
                                    label-for="institution"
                            >
                                <b-form-input
                                        id="nom"
                                        :value="etablissement"
                                        disabled
                                        type="text"
                                        placeholder=""
                                ></b-form-input>
                            </b-form-group>

                        </b-col>
                    </b-row>
                    <b-row >
                        <b-col sm="6">
                            <span  class="obligatoire">*</span>
                            <b-form-group
                                    id="nom-group"
                                    :label="$t('message.lastName')"
                                    label-for="nom"
                                    description=""

                            >

                                <b-form-input
                                        id="nom"
                                        v-model="$v.form.user.nom.$model"
                                        :state="$v.form.user.nom.$dirty ? !(errorshasField('nom') || $v.form.user.nom.$error) : null"
                                        type="text"
                                        placeholder=""
                                        @focus="clearErrorField('nom')"
                                ></b-form-input>

                                <b-form-invalid-feedback  v-if="!$v.form.user.nom.isNotUser">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('nom')">
                                    {{ getErrorsField('nom') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">

                            <b-form-group
                                    id="prenom-group"
                                    :label="$t('message.firstName')"
                                    label-for="prenom"
                            >
                                <b-form-input
                                        id="prenom"
                                        v-model="$v.form.user.prenom.$model"
                                        type="text"
                                ></b-form-input>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <b-form-group
                                    id="numero-group"
                                    :label="$t('message.phoneNumber')"
                                    label-for="numero"
                            >
                                <b-form-input
                                        id="numero"
                                        v-model="$v.form.user.telephone.$model"
                                        :state="$v.form.user.telephone.$dirty ? !(errorshasField('telephone') || $v.form.telephone.$error) : null"

                                        placeholder=""
                                        @focus="clearErrorField('telephone')"
                                ></b-form-input>
                                <b-form-invalid-feedback v-if="!$v.form.user.telephone.integer">
                                    {{ $t('message.integer', { n: 9 }) }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-if="!$v.form.user.telephone.minLength">
                                    {{ $t('message.minCharacters', { n: 9 }) }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-if="errorshasField('telephone')">
                                    {{ getErrorsField('telephone') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-col sm="6">
                            <span  class="obligatoire">*</span>

                            <b-form-group
                                    id="email-group"
                                    :label="$t('message.email')"
                                    label-for="email"
                            >
                                <b-form-input
                                        id="email"
                                        v-model="$v.form.user.email.$model"
                                        :state="$v.form.user.email.$dirty ? !(errorshasField('email') || $v.form.user.email.$error) : null"
                                        type="email"
                                        placeholder=""
                                        @focus="clearErrorField('email')"
                                ></b-form-input>

                                <b-form-invalid-feedback v-if="!$v.form.user.email.isNotUser">
                                    {{ $t('message.requiredField') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="!$v.form.user.email.email">
                                    {{ $t('message.emailNotValid') }}
                                </b-form-invalid-feedback>

                                <b-form-invalid-feedback v-else-if="errorshasField('email')">
                                    {{ getErrorsField('email') }}
                                </b-form-invalid-feedback>
                            </b-form-group>
                        </b-col>
                        <b-form-checkbox class="mt-5  ml-3" v-model="form.sexe" name="check-button" switch>
                            {{$t('message.gender')}} <b>{{ form.sexe=='M' ? $t('message.male') : $t('message.female')}}</b>
                        </b-form-checkbox>
                    </b-row>
                    <b-row class="justify-content-sm-center">
                        <b-button @click="onSubmit" variant="primary" v-if="can">
                            {{ $t('message.edit') }}
                        </b-button>
                    </b-row>
                </b-container>
            </b-form>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import _ from "lodash";
    import {email, maxLength, minLength, numeric, required} from "vuelidate/lib/validators";
    import SlimSelect from "slim-select";

    export default {
        name: "EditAssistant",
        computed: {
            ...mapGetters(["assistante", "errors", 'hasAdminRole',
                'hasGestionnaireRole','hasMedecinControleRole','hasAssistante']),

            can: function () {
                return this.hasAdminRole || this.hasGestionnaireRole || this.hasMedecinControleRole || this.hasAssistante;
            },

            form: function() {
                return this.assistante;
            },

            etablissement:function () {
                return this.form.etablissements.name;
            }
        },
        data() {
            return {
                assistante_id: this.$route.params.assistant,
                praticienSelect:Object,
            }
        },

        methods:{
            getAssistante() {
                let args = {
                    assistante: this.assistante_id,
                };
                this.$store.dispatch("getAssistante", {args});
            },


            getErrorsField(field){
                if (this.errorshasField(field)){
                    return this.errors[field][0];
                }else{
                    return  '';
                }
            },

            onSubmit(evt){
                evt.preventDefault();

                this.$v.$touch();

                if(!this.$v.$invalid) {
                    let args = {};

                    args.etablissement_id = this.form.etablissement_id;
                    args.assistante=this.assistante_id;
                    args.email = this.form.user.email;
                    args.nom = this.form.user.nom;
                    args.prenom = this.form.user.prenom;
                    args.sexe = this.form.user.sexe=='M' ? 'M' :'Mme';
                    args.telephone =  this.form.user.telephone;
                    args.user_id = this.form.user_id;

                    let successMessage = this.$i18n.t('message.assistanteUpdated');
                    let errorMessages = {
                        generic: this.$i18n.t('message.genericError'),
                        error: this.$i18n.t('message.genericError') // TODO: Prendre message approprié
                    };

                    this.$store.dispatch('updateAssistante', { args, errorMessages, successMessage })

                }

            },

            errorshasField(field){
                return this.errors ? this.errors.hasOwnProperty(field) : false;
            },

            clearErrorField(field){
                this.$store.dispatch('clearErrorField', { field });

                this.getErrorsField(field);
            },
        },

        validations() {
            return {
                form: {
                    user_id:{required},

                    user:{
                        nom: {
                            required
                        },

                        prenom: {

                        },

                        telephone: {
                            required,
                            minLength: minLength(9),
                            numeric
                        },

                        email: {
                            required,
                            email
                        },
                    }
                }
            }
        },
        mounted() {
            this.getAssistante();

        }
    }
</script>

<style scoped>

</style>